import React from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import Loader from 'Pods/Shared/Loader'

import MainContent from './Components/MainContent'

class Messaging extends React.Component {
  constructor() {
    super()

    this.state = {
      meta: {
        currentPage: 0,
        totalPages: 0,
      },
      isLoadingMore: false,
      messages: [],
      included: [],
      scrollBottomOffset: 0,
    }

    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.onFetchFailure = this.onFetchFailure.bind(this)
    this.onLoadMore = this.onLoadMore.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchData()
  }

  fetchData() {
    const config = {
      params: {
        page: Number(this.state.meta.currentPage || 0) + 1,
      },
      cancelToken: this.cancelSource.token,
    }

    axios.get(`/api/internal/conversations/${this.props.conversationId}/messages`, config)
      .then(this.onFetchSuccess)
      .catch(this.onFetchFailure)
  }

  onFetchSuccess(response) {
    this.setState({
      messages: [...(response.data.data.reverse()), ...this.state.messages],
      included: [...response.data.included, ...this.state.included],
      meta: response.data.meta,
      isLoadingMore: false,
    })
  }

  onFetchFailure(xhr, status, err) {
    this.setState({
      isLoadingMore: false,
    })
  }

  onLoadMore(messagesScrollBottomOffset) {
    this.setState({
      scrollBottomOffset: messagesScrollBottomOffset,
      isLoadingMore: true,
    })

    this.fetchData()
  }

  onSubmit(response) {
    this.setState({
      included: [...response.data.included, ...this.state.included],
      messages: update(this.state.messages, { $push: [response.data.data] }),
      scrollBottomOffset: 0,
    })
  }

  render() {
    if (this.state.messages.length === 0) {
      return (
        <Loader />
      )
    }

    return (
      <MainContent
        conversationId={this.props.conversationId}
        messages={this.state.messages}
        included={this.state.included}
        meta={this.state.meta}
        scrollBottomOffset={this.state.scrollBottomOffset}
        onLoadMore={this.onLoadMore}
        isLoadingMore={this.state.isLoadingMore}
        onSubmit={this.onSubmit}
        isSuspendedMessaging={false}
        isAttachmentsHidden={false}
        conversationType={this.props.conversationType}
        isJobConversation
      />
    )
  }
}

Messaging.propTypes = {
  conversationId: PropTypes.string.isRequired,
  isSuspendedMessaging: PropTypes.bool.isRequired,
  isAttachmentsHidden: PropTypes.bool.isRequired,
  isJobConversation: PropTypes.bool,
  conversationType: PropTypes.string.isRequired,
}

Messaging.defaultProps = {
  isJobConversation: false,
}

export default Messaging
